(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["makishop-tienda-real-ficha"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mk-store-tour')) {
    customElements.define('mk-store-tour', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const details = this.querySelector('details');
        if (!details) return;
        details.addEventListener('toggle', () => {
          const player = this.querySelector('.mk-store__player');
          if (details.open && !player.querySelector('video')) {
            player.append(player.querySelector('template').content.cloneNode(true));
          }
          if (!details.open) player.querySelector('video')?.pause();
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.querySelector('video')?.pause();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
